import { render, staticRenderFns } from "./StockListTransportOrders.vue?vue&type=template&id=2f915242"
import script from "./StockListTransportOrders.vue?vue&type=script&lang=js"
export * from "./StockListTransportOrders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports